import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

/* Права проверяем до действия входа: меню настроек и модалки открываются раньше поиска якоря */
export const adverseConditions: Record<string, () => boolean> = {
  'adverse.canSettings': () => {
    const adverse = usePermissionsStore().modules.adverse

    return Boolean(adverse?.type_edit || adverse?.probability)
  },
  'adverse.canEditTypes': () => Boolean(usePermissionsStore().modules.adverse?.type_edit),
  'adverse.canEditProbability': () => Boolean(usePermissionsStore().modules.adverse?.probability),
}
